import { render, staticRenderFns } from "./invitationRegister.vue?vue&type=template&id=e97d242e&scoped=true&"
import script from "./invitationRegister.vue?vue&type=script&lang=js&"
export * from "./invitationRegister.vue?vue&type=script&lang=js&"
import style0 from "./invitationRegister.vue?vue&type=style&index=0&id=e97d242e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e97d242e",
  null
  
)

export default component.exports